<div class="max-w-3xl mx-auto px-4 py-16">
  <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-4">À propos de Predivent</h1>
  <p class="text-lg text-gray-500 dark:text-gray-400 mb-10">
    Nous aidons les marchands à vendre plus et gaspiller moins.
  </p>
  <div class="space-y-8">
    <div class="flex gap-4">
      <div
        class="w-10 h-10 rounded-xl bg-purple-100 dark:bg-purple-900/30 flex items-center justify-center shrink-0 text-xl"
      >
        🎯
      </div>
      <div>
        <h2 class="font-semibold text-gray-900 dark:text-white mb-1">Notre mission</h2>
        <p class="text-gray-500 dark:text-gray-400 text-sm">
          Donner aux marchands itinérants et fixes les outils d'analyse que les
          grandes enseignes ont depuis des années, à un prix accessible.
        </p>
      </div>
    </div>
    <div class="flex gap-4">
      <div
        class="w-10 h-10 rounded-xl bg-purple-100 dark:bg-purple-900/30 flex items-center justify-center shrink-0 text-xl"
      >
        🧠
      </div>
      <div>
        <h2 class="font-semibold text-gray-900 dark:text-white mb-1">Notre approche</h2>
        <p class="text-gray-500 dark:text-gray-400 text-sm">
          Des algorithmes de prévision alimentés par vos propres données de
          vente, la météo et le contexte de chaque événement.
        </p>
      </div>
    </div>
    <div class="flex gap-4">
      <div
        class="w-10 h-10 rounded-xl bg-purple-100 dark:bg-purple-900/30 flex items-center justify-center shrink-0 text-xl"
      >
        🌱
      </div>
      <div>
        <h2 class="font-semibold text-gray-900 dark:text-white mb-1">Impact environnemental</h2>
        <p class="text-gray-500 dark:text-gray-400 text-sm">
          Moins de gaspillage alimentaire, c'est aussi moins d'impact sur la
          planète. Chaque recommandation précise compte.
        </p>
      </div>
    </div>
  </div>
  <div class="mt-12 text-center">
    <a
      routerLink="/contact"
      class="inline-block px-6 py-3 bg-purple-600 text-white rounded-xl font-semibold hover:bg-purple-700 transition"
      >Nous contacter</a
    >
  </div>
</div>
